export { default, getServerSideProps } from '@/views/CouponsLanding';
